import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "log-out",
  "use": "log-out-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"log-out\"><path fill-rule=\"evenodd\" d=\"M15 2a2 2 0 0 1 2 2v2h-2V4H4v16h11v-2h2v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h11Zm2 12h-7v-4h7V7l5 5-5 5v-3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol